<template>
    <div class="test-view test-details-view past-test-student-view qiid-question-past-test">
        <div>
            <v-breadcrumbs >
                <template >
                    <v-breadcrumbs-item>
                        <span
                            class="light-text"
                            >Tests /
                        </span>
                    </v-breadcrumbs-item>
                    <v-breadcrumbs-item>
                        <span class="light-text"> {{breadcrumb}} /</span>
                    </v-breadcrumbs-item>
                    <v-breadcrumbs-item>
                        <span class="light-text"> {{currentQuestion ? currentQuestion.question_id : ''}}</span>
                    </v-breadcrumbs-item>                                
                </template>
            </v-breadcrumbs>
        </div>
        <div class="test-page-section qiid-question-view">
            <div class="test-btn-quection">
                <v-card class="mx-auto normal-card live-test-hg">
                    <div class="slide-btn-group cust-slide">
                        <div class="QIDtext-bold">
                            <div class="chapter-info-block">
                                        <div class="chapter-info" >Chapter Name:
                                            <!-- <span>{{currentQuestion.chapterName}}</span> -->
                                            <v-tooltip left  bottom content-class="cust-new-tooltip-top search-another-drop-easy open-top">
			                                <template  v-slot:activator="{ on }">                  
                                                <span
                                                v-on="on"
                                                depressed
                                                 :class="{
                                                        'text-transform-none': true,
                                                       
                                                    }"                
                                                >{{currentQuestion.chapterName}}</span>
										    </template>
										    <span > {{currentQuestion.chapterName}}</span>
										    </v-tooltip>
                                        </div>
                                        <div class="chapter-info"  v-if="currentQuestion.topicName !== null">Topic Name:
                                            <!-- <span>{{currentQuestion.topicName}}</span> -->
                                            <v-tooltip left  bottom content-class="cust-new-tooltip-top search-another-drop-easy open-top">
			                                <template  v-slot:activator="{ on }">
                                                                    
                                                <span
                                                    v-on="on"
                                                    depressed
                                                    :class="{
                                                        'text-transform-none': true, 
                                                    }"            
                                                >{{currentQuestion.topicName}}</span>
										    </template>
										    <span > {{currentQuestion.topicName}}</span>
										    </v-tooltip>
                                        </div>
                                        <div class="chapter-info">Level: 
                                            <!-- <span>{{currentQuestion.difficulty}}</span> -->
                                            <v-tooltip left  bottom content-class="cust-new-tooltip-top search-another-drop-easy open-top">
			                                <template  v-slot:activator="{ on }">             
                                                <span
                                                    v-on="on"
                                                    depressed
                                                        :class="{
                                                        'text-transform-none': true,
                                                    }"            
                                                    >{{currentQuestion.difficulty}}</span>
										    </template>
										    <span >{{currentQuestion.difficulty}}</span>
										    </v-tooltip>
                                        </div>
                                    </div>
                            <div class="next-que-btn">
                                <v-btn
                                    v-if="!isLastQuestion"
                                    color="primary"
                                    class="cust-btn right-align report_error_btn"
                                    @click="nextQuestion()"
                                    >Next
                                </v-btn>
                                <v-btn
                                    v-if="!this.bookmarkQuestion"
                                    color="primary"
                                    class="cust-btn right-align"
                                    @click="addBookmark()"
                                    >Bookmark Question
                                </v-btn>
                                <v-btn
                                    v-if="this.bookmarkQuestion"
                                    color="primary"
                                    class="cust-btn right-align"
                                    @click="removeBookmark()"
                                    >Remove
                                </v-btn>
                            </div>
                        </div>
                    </div>
                    <pinch-zoom class="pinch-zoom" disableZoomControl="disable" :wheel="false">
                        <div class="tst-quection-block" ref="questionBox">
                            <div v-if="questionData && questionTypes">
                                <div>
                                    <Comprehension
                                        :showAnswerField="true"
                                        :currentQuestion="currentQuestion"
                                        :QIdView="QIdView"
                                        v-if="currentQuestion.question_type == questionTypes.COMPREHENSION || currentQuestion.question_type == questionTypes.TC"
                                    />
                                    <SingleAnsQuePrivew
                                        :showAnswerField="true"
                                        :currentQuestion="currentQuestion"
                                        :QIdView="QIdView"
                                        v-if="currentQuestion.question_type == questionTypes.SINGLE_CORRECT ||currentQuestion.question_type == questionTypes.SINGLE_CORRECT_SEC2 ||  currentQuestion.question_type == questionTypes.ASSERTION_REASON"
                                    />
                                    <MultipleCorrectPrivew
                                        :showAnswerField="true"
                                        :currentQuestion="currentQuestion"
                                        :QIdView="QIdView"
                                        v-if="currentQuestion.question_type == questionTypes.MULTIPLE_CORRECT"
                                    />
                                    <IntegerPrivew
                                        :showAnswerField="true"
                                        :currentQuestion="currentQuestion"
                                        :QIdView="QIdView"
                                        v-if="currentQuestion.question_type == questionTypes.INTEGER"
                                    />
                                    <SubjectivePrivew
                                        :showAnswerField="true"
                                        :currentQuestion="currentQuestion"
                                        :QIdView="QIdView"
                                        v-if="currentQuestion.question_type == questionTypes.SUBJECTIVE || currentQuestion.question_type == questionTypes.SUBJECTIVEINTEGER"
                                    />
                                    <MatrixMatchPrivew
                                        :showAnswerField="true"
                                        :currentQuestion="currentQuestion"
                                        :QIdView="QIdView"
                                        v-if="currentQuestion.question_type == questionTypes.MATRIX_MATCH"
                                    />

                                    <MatrixMatchOptionPrivew
                                        :showAnswerField="true"
                                        :currentQuestion="currentQuestion"
                                        :QIdView="QIdView"
                                        v-if="currentQuestion.question_type == questionTypes.MATRIX_MATCH_OPTION"
                                    />
                                </div>
                               
                            </div>                          
                        </div>
                    </pinch-zoom>
                </v-card>
            </div>
            <div class="test-counter-block pasterrorblk show-desktop-panel">
                <div class="test-time-count">
                    <div class="time-remaining-title">
                        <v-btn
                            color="primary"
                            class="cust-btn right-align"
                            @click="openReportErrorDialog"
                            v-if="currentQuestion.institute_id === null"
                        >Report Error</v-btn>
                    </div>
                </div>
                <div class="inner-block">
                    <div class="number-contet scrollable-video">
                        <VideoList :videoList="videoList"  />
                    </div>
                    <!-- <div class="test-foter-blk">
                        <div class="test-btn-block-ans">
                            <div class="marking marking-bold">Marking Scheme for this section:</div>
                            <div
                                class="marking"
                            >Correct Response:+ {{currentQuestion.correct_marks}}</div>
                            <div
                                class="marking"
                            >Incorrect Response:{{currentQuestion.negative_marks}}</div>
                        </div>
                    </div> -->
                </div>
                <div class="similar-questions-btn">
                    <v-btn
                    v-if="checkBoostupSubscription()"
                    color="#EEBC1D" class="yellow-btn similar-questions"
                    @click="closeQuestionPreview()"
                    >Practice Similar Questions</v-btn
                    >
                </div>
                <div class="finish-test-btn">
                    <v-btn
                    color="default"
                    class="cust-btn finish-test"
                    @click="closeQuestionPreview()"
                    >Close Preview</v-btn
                    >
                </div>
            </div>
        </div>
        <div class="test-bottom logo-btm">
            <div class="bottom-logo">
                <!-- <img src="/img/logo-footer.c1b83f14.png" class="master-logo-btm" /> -->
            </div>
            <div class="test-btn-block-answering">
                <div class="progress-area chapternamehealthdisp">
                    <div class="health-progress">
                        <div class="chpter-hlth">Chapter Name: </div>
                         <div class="chpter-prog">
                            <v-tooltip left  bottom content-class="cust-new-tooltip-top search-another-drop-easy open-top">
                            <template  v-slot:activator="{ on }">          
                                <span
                                    v-on="on"
                                    depressed
                                        :class="{
                                        'text-transform-none tooltip-chapter': true,
                                        
                                    }"            
                                    >{{currentQuestion.chapterName}}</span>
                            </template>
                            <span >{{currentQuestion.chapterName}}</span>
							</v-tooltip>
                        </div>
                    </div>
                    <div class="health-progress">
                        <div class="chpter-hlth">Chapter Health:</div>
                        <div class="chpter-prog">
                            <ProgressBar :height="20" :value="currentQuestion.chapterHealth" />
                        </div>
                    </div>
                </div>
                <div class="progress-area">
                    <div class="health-progress">
                        <div class="chpter-hlth"  v-if="currentQuestion.topicName !== null">Topic Name:</div>
                          <div class="chpter-prog">
                            <v-tooltip left  bottom content-class="cust-new-tooltip-top search-another-drop-easy open-top">
                            <template  v-slot:activator="{ on }">
                                                    
                                <span
                                    v-on="on"
                                    depressed
                                        :class="{
                                        'text-transform-none tooltip-chapter': true,
                                        
                                    }"
                                                        
                                    >{{currentQuestion.topicName}}</span>
                                                                        
                            
                            </template>
                            <span >{{currentQuestion.topicName}}</span>
							</v-tooltip>
                        </div>
                    </div>
                    <div class="health-progress">
                        <div class="chpter-hlth" v-if="currentQuestion.topicName !== null">Topic Health:</div>
                        <div class="chpter-prog" v-if="currentQuestion.topicName !== null"  >
                            <ProgressBar :height="20" :value="currentQuestion.topicHealth" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <AlertBox
            :width="modalWidth"
            :onClose="onClose"
            :component="cComponent"
            :status="status"
            :data="alertBoxData"
        />
    </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
import * as youtubeSearch from "youtube-search";
import ProgressBar from "@/components/common/ProgressBar.vue";

import { mapActions, mapState, mapMutations, mapGetters } from "vuex";

import QuestionPallet from "@/components/PreviewTest/QuestionPallet.vue";
import MiniQuestionPallet from "@/components/PreviewTest/MiniQuestionPallet.vue";
import LegendsPastTest from "@/components/PreviewTest/LegendsPastTest.vue";
import LegendsOnHover from "@/components/PreviewTest/LegendsOnHover.vue";
import Comprehension from "@/components/PreviewTest/Comprehension.vue";
import SingleAnsQuePrivew from "@/components/PreviewTest/SingleAnsQuePrivew.vue";
import MultipleCorrectPrivew from "@/components/PreviewTest/MultipleCorrectPrivew.vue";
import IntegerPrivew from "@/components/PreviewTest/IntegerPrivew.vue";
import SubjectivePrivew from "@/components/PreviewTest/SubjectivePrivew.vue";
import AssertionReasonPrivew from "@/components/PreviewTest/AssertionReasonPrivew.vue";
import MatrixMatchOptionPrivew from "@/components/PreviewTest/MatrixMatchOptionPrivew.vue";
import MatrixMatchPrivew from "@/components/PreviewTest/MatrixMatchPrivew.vue";
import VideoList from "@/components/common/VideoList.vue"

import constants from "@/utils/constants.js";

export default {
    name: "BookmarkAttemptQidView",
    components: {
        QuestionPallet,
        MiniQuestionPallet,
        LegendsPastTest,
        LegendsOnHover,
        Comprehension,
        SingleAnsQuePrivew,
        MultipleCorrectPrivew,
        IntegerPrivew,
        SubjectivePrivew,
        AssertionReasonPrivew,
        MatrixMatchOptionPrivew,
        MatrixMatchPrivew,
        Carousel,
        Slide,
        ProgressBar,
        VideoList
    },
    async mounted() {
        this.testDetailId = this.$route.params.test_detail_id;
        this.page = this.$route.params.index+1;
        // if(this.$route.params.requiredCall=="attempted-questions"){
        // this.breadcrumb = "Attempted Questions"
        // }
        // if(this.$route.params.requiredCall=="bookmarked-questions"){
        // this.breadcrumb = "Bookmarked Questions"
        // }
        this.questionTypes = this.QUE_TYPES;
        this.questionStatus = this.QUESTION_STATUS;
        this.questionStatusColor = this.QUESTION_STATUS_COLOR;
       // this.getQuestion();
      //  this.getQuestionData();      

    },
    // beforeDestroy() {
    //     this.scrollToTop();
    // },
    data() {
        return {
            isTestCustom: false,
            isShowReportErrorBtn: true,
            modalWidth: null,
            instructionsTooltip: null,
            cComponent: "components/coordinator/Questionadd",
            alertBoxData: {},
            persistent: false,
            status: false,
            testDetails: null,
            questionTypes: this.QUE_TYPES,
            questionStatus: this.QUESTION_STATUS,
            questionStatusColor: this.QUESTION_STATUS_COLOR,
            questionTypesReversed: {},
            questionData: {},
            questions: [],
            question: [],
            currentQuestion: {},
            legendsData: {
                correct: 0,
                incorrect: 0,
                notAttempted: 0,
                partiallyCorrect: 0,
            },
            instructions: "",
            scrollPerPage: false,
            direction: "",
            perPageCustom: [
                [1900, 6],
                [1650, 5],
                [1550, 4],
                [1400, 3],
                [1300, 3],
                [1280, 3],
                [1024, 2],
                [768, 2],
                [480, 1],
                [340, 1],
            ],
            isEditing: false,
            expansionPanelStatus: null,
            subTopicName: "",
            videoList: {
                taggedConcepts: [],
                mainConcept: [],
                subTopic: []
            },
            difficulty: constants.DIFFICULTY_LEVELS,
            selectedSubject:'',
            QIdView: true,
            bookmarkQuestion: false,
            text1:"Bookmark Question",
            text2:"Remove",
            subjectQuestionTypeList: [],
            selectedTestId: null,
            page: 1,
            pageCount: [],
            breadcrumb: "",
            testDetailId: null,
        };
    },
    computed: {
        ...mapGetters("testStore", {
        //     questionsListStore: "questionsList",
        //     filteredQuestionsList: "filteredQuestionsList",
        //     testData: "testData",
            // subjectQuestionTypeList: "subjectQuestionTypeList",
        //     selectedSQTIndex: "selectedSQTIndex",
        //     isPastTest: "isPastTest",
        }),
        ...mapState("userStore", ["user"]),
        isLastQuestion() {
            if (
                this.page == this.pageCount.rowCount
            ) {
                return true;
            } else {
                return false;
            }
        },
    },
    watch: {
        // 'currentQuestion.id': function (currentQuestion) {
        //     this.getMainConceptVideos();
        //     this.getSubTopicVideos();
        //     //this.getTaggedConceptVideos();
        // }
    },
    methods: {
        ...mapActions({
            // getBookmarkQuestion: "testStore/getBookmarkQuestion",
            // addBookmarkQuestion: "testStore/addBookmarkQuestion",
            // removeBookmarkQuestion: "testStore/removeBookmarkQuestion",
            // getAttemptedQuestions: "testStore/getAttemptedQuestions",
        }),
        ...mapMutations("app", ["addBreadCrumbChilde"]),
   
        getQuestion() {
            let postData = {
                test_detail_id : this.testDetailId,
                user_id: this.user.id,
                orderBy: {
                    order: "asc",
                    field: "response"
                },
                question_details_required: 1,
                pagination: {
                pageSize: 1,
                page: this.page
                }
                //requiredDetails: true,
            };
            //this.$root.showLoader = true;
            // let fn = this.functionCalls;
            // if (this.$route.params.requiredCall == "bookmarked-questions") {
            //     fn = "getBookmarkQuestion";
            // }
            // else if(this.$route.params.requiredCall == "attempted-questions") {
            //     fn = "getAttemptedQuestions";
            // }
            //     this[fn](postData)
            //         .then((response) => {
            //             this.question = response.list;
            //             this.testDetailId = response.list[0].test_detail_id;
            //             this.pageCount = response.pagination;
            //             let processedQuestion = this.processQuestion(response.list);
            //             this.$root.showLoader = false;
            //         })
            //         .catch((err) => {
            //             // this.$root.showLoader = false;
            //         });
        },
        processQuestion(questionData) {
            //this.bookmarkQuestion = questionData[0].question_details.question_bookmark == 1 ? true : false;
            let q = questionData[0].question_details; // current question in loop
            this.subjectQuestionTypeList = [questionData[0].question_details]; // current question in loop
            q.user_selected_answer = questionData[0].yourAnswer;
            let questionTypeId = q.question_type;
            questionTypeId =
                questionTypeId == this.questionTypes.COMPREHENSION ||
                questionTypeId == this.questionTypes.TC
            ? q.subtype.id ?q.subtype.id :q.subtype
                    : q.question_type;
            let currentQuestion = {};
            currentQuestion = this.generateQuestionObject(questionTypeId, q);
        currentQuestion.subtype = q.subtype ? q.subtype.id ?q.subtype.id :q.subtype:'';
            if (
                q.question_type == this.questionTypes.COMPREHENSION ||
                q.question_type == this.questionTypes.TC
            ) {
                currentQuestion.passage = q.passage;
            }
            currentQuestion = this.getCurrentQuestionCommonKeys(
                currentQuestion,
                q
            );
            currentQuestion.question_id = questionData[0].question_id;
            currentQuestion.chapterName = questionData[0].question_details.chapter_title;
            currentQuestion.chapterHealth = questionData[0].question_details.chapter_health;
            currentQuestion.topicName = questionData[0].question_details.topic_title;
            currentQuestion.topicHealth = questionData[0].question_details.topic_health;
            currentQuestion.level = questionData[0].question_details.datatype.level;
            currentQuestion.conceptName = questionData[0].question_details.concept_title;
            currentQuestion.subTopicName = questionData[0].question_details.subtopic_title;
            currentQuestion.institute_id = questionData[0].question_details.institute_id; 
            currentQuestion.solution = questionData[0].question_details.solution;
            currentQuestion.difficulty = q.difficulty_level;
            currentQuestion.isPreview = true;
            currentQuestion.institute_id = questionData[0].question_details.solution;;
            if (q.difficulty_level) {
                currentQuestion.difficulty_level = q.difficulty_level || null;
                currentQuestion.difficulty = this.difficulty.find(
                (d) => d.id === q.difficulty_level
                ).title;
            }
            this.currentQuestion = currentQuestion;
            return currentQuestion;
        },
        getVideos(noOfVideos, searchText) {
            return new Promise((resolve, reject) => {
                var opts = {
                    maxResults: noOfVideos,
                    key: this.YOUTUBE_SEARCH_API_KEY // change key once deploying on prod from google apis by creating a new project
                };
                 let searchTextt = this.selectedSubject  + " " + searchText
                youtubeSearch(searchTextt, opts, (err, results) => {
                    if(err) {
                        resolve(false);
                    }
                    resolve(results);
                });
            });
        },
        async  getSubTopicVideos() {
            if(this.currentQuestion.subTopicName && this.currentQuestion.subTopicName == 'General') {
                return;
            }
            let subTopicName = this.currentQuestion.subTopicName ? this.currentQuestion.subTopicName.substr(this.currentQuestion.subTopicName.indexOf('.') + 1) : null;
            if(subTopicName) {
                let videos = await this.getVideos(4, subTopicName);
                this.videoList.subTopic = videos;
            }
        },
        async getTaggedConceptVideos() {
            let tc = [];
            if(this.currentQuestion.taggedConcepts && this.currentQuestion.taggedConcepts.length) {

                for (let i = 0; i < this.currentQuestion.taggedConcepts.length; i++) {
                    const t = this.currentQuestion.taggedConcepts[i];
                    if(t.tag != 'No Video' && t.tag != 'Source_Booklet') {
                        // tc.push({
                        //     tag: t.tag.substr(18)                        
                        // })
                        let videos = await this.getVideos(2, t.tag.substr(t.tag.indexOf('.') + 1))
                        tc.push({
                            tag: t.tag.substr(18),
                            videos
                        })
                    }
                }
            }
            if(tc && tc.length) {
                this.videoList.taggedConcepts = tc;
            }
        },
        async getMainConceptVideos() {
            if(this.currentQuestion.conceptName && this.currentQuestion.conceptName == 'General') {
                return;
            }
            let conceptName = this.currentQuestion.conceptName ? this.currentQuestion.conceptName.substr(this.currentQuestion.conceptName.indexOf('.') + 1) : null;
            if(conceptName) {
                let videos = await this.getVideos(2, conceptName);
                this.videoList.mainConcept = videos;
            }
        },
        closeQuestionPreview() {
            localStorage.setItem("previousPath", this.$route.path);
           this.$router.push({ name: "practice-session-question-view" });
            // if(this.$route.params.requiredCall=="bookmarked-questions"){
            // this.$router.push({ name: "bookmarked-questions" });
            // }
            // if(this.$route.params.requiredCall=="attempted-questions"){
            // this.$router.push({ name: "attempted-questions" });
            // }
        },
        openReportErrorDialog() {
            this.alertBoxData = {
                question: this.currentQuestion,
                errorDescription: "",
            };
            this.modalWidth = "1000px";
            this.status = true;
            this.cComponent = "components/student/Tests/PastTests/ReportError";
            this.$forceUpdate();
        },
        async nextQuestion() {
            this.page = parseInt(this.page) + 1;
            this.getQuestion();
        },
        getCurrentQuestionCommonKeys(currentQuestion, q) {
            currentQuestion.id = q.id;
            currentQuestion.questionNo = q.index;
            currentQuestion.question_text = q.question_text;
            currentQuestion.question_id = q.question_id;
            currentQuestion.question_type = q.question_type;
            currentQuestion.questionType = { id: q.question_type };
            currentQuestion.parent_id = q.parent_id;
            currentQuestion.section_id = q.section_id;
            currentQuestion.test_detail_id = q.test_detail_id;
            currentQuestion.correct_marks = q.marks;
            currentQuestion.negative_marks = q.negative_marks;
            currentQuestion.partial_marking = q.partial_marking;
            currentQuestion.solution = q.solution;
            currentQuestion.hints = q.hints;
            currentQuestion.isBonus = q.is_bonus;
            currentQuestion.userSelectedAnswer = q.user_selected_answer;
            currentQuestion.status = this.questionStatus.INITIAL; // "status" along with "isAnswered" will be used for loading legends & pallet info
            currentQuestion.isAnswered = false; // to know if the current question is answered.
            currentQuestion.disabled = true;
            currentQuestion.ansStatus = this.PAST_QUESTION_STATUS.NOT_ATTEMPTED;
            currentQuestion.institute_id = q.institute_id;
            currentQuestion.subType = q.subtype;
            let om = q.obtained_mark ? q.obtained_mark : 0;
            currentQuestion.obtained_mark = om;
            let marks = q.marks;
            // if (
            //     currentQuestion.questions &&
            //     (currentQuestion.question_type == this.questionTypes.TC ||
            //         currentQuestion.question_type ==
            //             this.questionTypes.COMPREHENSION)
            // ) {
            //     marks = marks * currentQuestion.questions.length;
            // }

            if (q.user_selected_answer) {
                let answer = q.user_selected_answer;
                currentQuestion.isAnswered = answer.answer ? true : false;
                currentQuestion.status = answer.status;
            }
            if (currentQuestion.institute_id == null) {
                this.isShowReportErrorBtn = false;
            }
            if (om == marks) {
                currentQuestion.ansStatus = this.PAST_QUESTION_STATUS.CORRECT;
            } else if (om > 0 && om < marks) {
                currentQuestion.ansStatus = this.PAST_QUESTION_STATUS.PARTIALLY_CORRECT;
            } else if (currentQuestion.isAnswered && om < 1) {
                currentQuestion.ansStatus = this.PAST_QUESTION_STATUS.INCORRECT;
            }

            return currentQuestion;
        },
        getCQRType1(type, q) {
            let responseData = {
                options: [],
                yourAnswer: "",
                correctAnswer: "",
            };
            let correctOptions = _.cloneDeep(q.options);
            let correctAnswer = [];
            let yourAnswer = [];
            let options = q.options.map((o) => {
                return { ...o, ...{ correct_answer: false } };
            });

            correctOptions.forEach((o) => {
                if (parseInt(o.correct_answer)) {
                    correctAnswer.push(o.index);
                }
            });

            if (q.user_selected_answer) {
                let option = null;
                let answer = JSON.parse(q.user_selected_answer);
                if (answer.answer) {
                    let switchType = 1;
                    if (
                        this.questionTypes.ASSERTION_REASON == type ||
                        this.questionTypes.SINGLE_CORRECT == type ||
                        this.questionTypes.SINGLE_CORRECT_SEC2 == type ||
                        this.questionTypes.COMPREHENSION_2Q_SA == type ||
                        this.questionTypes.COMPREHENSION_2Q_MM == type ||
                        this.questionTypes.COMPREHENSION_3Q_SA == type ||
                        this.questionTypes.TC_2Q_SA == type ||
                        this.questionTypes.TC_3Q_SA == type
                    ) {
                        switchType = 1;
                    } else {
                        switchType = 2;
                    }
                    switch (switchType) {
                        case 1:
                            option = options.find(
                                (o) => o.id == answer.answer.option_id
                            );
                            if (option) {
                                yourAnswer.push(option.index);
                                option.correct_answer = true;
                            }
                            break;

                        case 2:
                            answer.answer.option_id.map((a) => {
                                option = options.find((o) => o.id == a);
                                if (option) {
                                    yourAnswer.push(option.index);
                                    option.correct_answer = true;
                                }
                            });
                            break;
                    } // end of switch
                }
            }

            responseData.options = options;
            responseData.yourAnswer = yourAnswer.join(", ");
            responseData.correctAnswer = correctAnswer.join(", ");
            return responseData;
        },
        getCQRType2(q) {
            let responseData = {
                yourAnswer: "",
                correctAnswer: (q.correct_answer.split('##')),
            };
            if(responseData.correctAnswer.length && responseData.correctAnswer.length > 0) {
                responseData.correctAnswer = responseData.correctAnswer.join(' - ');
            }
            if (q.user_selected_answer) {
                let answer = JSON.parse(q.user_selected_answer);
                let yourAnswer = answer.answer
                    ? parseFloat(answer.answer)
                    : null;
                responseData.yourAnswer = yourAnswer;
            }

            return responseData;
        },
        generateQuestionObject(typeId, q) {
            let type = "";
            type = this.getQuestionType(typeId);
            let currentQuestion = {};
            currentQuestion = this.getCurrentQuestionCommonKeys(
                currentQuestion,
                q
            );
            let cqr = null;
            switch (type) {
                case 1:
                    // cqr - currentQuestionResult
                    cqr = this.getCQRType1(typeId, q);
                    currentQuestion.options = cqr.options;
                    currentQuestion.yourAnswer = cqr.yourAnswer;
                    currentQuestion.correctAnswer = cqr.correctAnswer;
                    break;
                case 2:
                    cqr = this.getCQRType2(q);
                    currentQuestion.correct_answer = cqr.yourAnswer;
                    currentQuestion.yourAnswer = cqr.yourAnswer;
                    currentQuestion.correctAnswer = cqr.correctAnswer;
                    break;
                case 3:
                    cqr = this.separateOptions(q, 1);
                    currentQuestion.options_abc = cqr.options_abc;
                    currentQuestion.options_pqr = cqr.options_pqr;
                    currentQuestion.yourAnswer = cqr.yourAnswer;
                    currentQuestion.correctAnswer = cqr.correctAnswer;

                    break;
                case 4:
                    cqr = this.separateOptions(q, 2);
                    currentQuestion.options_abc = cqr.options_abc;
                    currentQuestion.options_pqr = cqr.options_pqr;
                    currentQuestion.options = cqr.op;
                    currentQuestion.yourAnswer = cqr.yourAnswer;
                    currentQuestion.correctAnswer = cqr.correctAnswer;

                    break;
                case 6:
                    cqr = this.getCQRType2(q);
                    currentQuestion.correct_answer = cqr.yourAnswer;
                    currentQuestion.yourAnswer = cqr.yourAnswer;
                    currentQuestion.correctAnswer = cqr.correctAnswer;
                    break;
            }
            return currentQuestion;
        },
        getQuestionType(id) {
            if (
                id == this.questionTypes.ASSERTION_REASON ||
                id == this.questionTypes.MULTIPLE_CORRECT ||
                id == this.questionTypes.SINGLE_CORRECT ||
                id == this.questionTypes.SINGLE_CORRECT_SEC2 ||
                id == this.questionTypes.COMPREHENSION_2Q_SA ||
                id == this.questionTypes.COMPREHENSION_2Q_MM ||
                id == this.questionTypes.COMPREHENSION_2Q_MA ||
                id == this.questionTypes.COMPREHENSION_3Q_SA ||
                id == this.questionTypes.COMPREHENSION_3Q_MA ||
                id == this.questionTypes.TC_2Q_SA ||
                id == this.questionTypes.TC_3Q_SA
            ) {
                return 1;
            } else if (id == this.questionTypes.INTEGER) {
                return 2;
            } else if (id == this.questionTypes.MATRIX_MATCH) {
                return 3;
            } else if (id == this.questionTypes.MATRIX_MATCH_OPTION) {
                return 4;
            } else if (
                id == this.questionTypes.COMPREHENSION ||
                id == this.questionTypes.TC
            ) {
                return 5;
            } else if (id == this.questionTypes.SUBJECTIVE|| id == this.questionTypes.COMPREHENSION_2Q_NU || id == this.questionTypes.SUBJECTIVEINTEGER) {
                return 6;
            }
        },
        onClose(data) {
            this.status = data.status;
        },
        separateOptions(q, type) {
            let options = q.options;
            let op = [];
            let options_abc = [];
            let options_pqr = [];

            let correctAnswer = [];
            let yourAnswer = [];

            options.forEach((option) => {
                // separate options: options (op), options_abc, options_pqr
                if (option.column == 1) {
                    option.correct_answer = option.correct_answer
                        ? option.correct_answer
                        : "";
                    options_abc.push(option);
                } else if (option.column == 2) options_pqr.push(option);
                else {
                    option.correct_answer = option.correct_answer
                        ? option.correct_answer
                        : false;
                    op.push(option);
                }
            });

            // get correct answer
            if (type == 2) {
                // matrix match options
                op.forEach((o, idx) => {
                    if (parseInt(o.correct_answer)) {
                        correctAnswer.push(o.index);
                        op[idx].correct_answer = false;
                    }
                });
            }
            if (type == 1) {
                // matrix match
                options_abc.forEach((o, idx) => {
                    if (o.correct_answer > "") {
                        correctAnswer.push({
                            index: o.index,
                            value: o.correct_answer,
                        });
                        options_abc[idx].correct_answer = "";
                    }
                });
            }

            if (type == 1) {
                // type = 1 : matrix match
                if (q.user_selected_answer) {
                    let answer = JSON.parse(q.user_selected_answer);
                    if (answer.answer) {
                        answer.answer.map((a) => {
                            let option = options_abc.find(
                                (o) => o.id == a.option_id
                            );
                            if (option) {
                                yourAnswer.push({
                                    index: option.index,
                                    value: a.value,
                                });
                                option.correct_answer = a.value;
                            }
                        });
                    }
                }
                let ya = yourAnswer.map((answer) => {
                    let ans =
                        answer.index + ": " + this.separateVals(answer.value);
                    return ans;
                });
                ya = ya.join(" | ");
                let ca = correctAnswer.map((answer) => {
                    let ans = answer.index + ": " + this.separateVals(answer.value);
                    return ans;
                });
                ca = ca.join(" | ");
                yourAnswer = ya;
                correctAnswer = ca;
            } else if (type == 2) {
                // type = 2 : matrix match options
                if (q.user_selected_answer) {
                    let answer = JSON.parse(q.user_selected_answer);
                    if (answer.answer) {
                        let option = op.find(
                            (o) => o.id == answer.answer.option_id
                        );
                        if (option) {
                            yourAnswer.push(option.index);
                            option.correct_answer = true;
                        }
                    }
                }
                yourAnswer = yourAnswer.join(", ");
                correctAnswer = correctAnswer.join(", ");
            }

            return {
                op,
                options_abc,
                options_pqr,
                yourAnswer,
                correctAnswer,
            };
        },
        addBookmark() {
            let reqData = {
                user_id: this.user.id,
                test_detail_id : this.testDetailId,
            };
            // this.addBookmarkQuestion(reqData)
            //     .then((response) => {
            //         this.$toasted.success(`Question bookmark added successfully.`, {});
            //     })
            //     .catch((err) => {
            //         this.$toasted.error(`Adding Bookmarked Question failed.`, {});
            //         //this.loading = false;
            //     });
            // this.bookmarkQuestion = true;
        },
        removeBookmark() {
            let reqData = {
                user_id: this.user.id,
                test_detail_id : this.testDetailId,
            };

            // this.removeBookmarkQuestion(reqData)
            //     .then((response) => {
            //         this.$toasted.success(`Question bookmark removed successfully.`, {});
            //         if (this.$route.params.requiredCall == "bookmarked-questions") {
            //             this.getQuestion();
            //         }
            //     })
            //     .catch((err) => {
            //         this.$toasted.error(`Remove Bookmarked Question failed.`, {});
            //     });
               // this.bookmarkQuestion = false;
        },
    },
};
</script>